import {
  FETCH_USERS_STARTED,
  FETCH_USERS_COMPLETED,
  FETCH_USERS_ERROR,
  DELETE_USER_STARTED,
  DELETE_USER_COMPLETED,
  DELETE_USER_ERROR,
  EDIT_USER_STARTED,
  EDIT_USER_COMPLETED,
  EDIT_USER_ERROR,
  ADD_USERDETAIL_STARTED,
  ADD_USERDETAIL_COMPLETED,
  UPDATE_USER_STARTED,
  UPDATE_USER_COMPLETED,
  UPDATE_USER_ERROR,
  ADD_USER_STARTED,
  ADD_USER_COMPLETED,
  ADD_USER_ERROR
} from '../actionTypes/userActionTypes';

const INITIAL_STATE = {
  submitted: false,
  success: false,
  error: false,
  users: {},
  user: {}
};

function userReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case ADD_USER_STARTED: {
      return {
        ...state,
        submitted: true
      };
    }
    case ADD_USER_COMPLETED: {
      let key = action.payLoad.id;
      let data = action.payLoad.data;
      state.users[key] = data;
      return {
        ...state,
        submitted: false,
        success: true
      };
    }
    case ADD_USER_ERROR: {
      return {
        ...state,
        submitted: false,
        error: true
      };
    }
    case FETCH_USERS_STARTED: {
      return {
        ...state,
        submitted: true
      };
    }
    case FETCH_USERS_COMPLETED: {
      if (action.payLoad) {
        return {
          ...state,
          users: { ...action.payLoad },
          submitted: false,
          success: true
        };
      } else {
        return {
          ...state,
          submitted: false,
          success: true
        };
      }
    }
    case FETCH_USERS_ERROR: {
      return {
        ...state,
        submitted: false,
        error: true
      };
    }
    case DELETE_USER_STARTED: {
      return {
        ...state,
        submitted: true
      };
    }
    case DELETE_USER_COMPLETED: {
      let result = {};
      Object.keys(state.users).filter((key) => {
        if (key !== action.payLoad) {
          result[key] = state.users[key];
        }
      });
      return {
        ...state,
        users: { ...result },
        submitted: false,
        success: true
      };
    }
    case DELETE_USER_ERROR: {
      return {
        ...state,
        submitted: false,
        error: true
      };
    }
    case ADD_USERDETAIL_STARTED: {
      return {
        ...state,
        submitted: true
      };
    }
    case ADD_USERDETAIL_COMPLETED: {
      return {
        ...state,
        user: { ...action.payLoad },
        submitted: false,
        success: true
      };
    }
    case EDIT_USER_STARTED: {
      return {
        ...state,
        submitted: true
      };
    }
    case EDIT_USER_COMPLETED: {
      let key = action.payLoad.id;
      let data = action.payLoad.data;
      state.users[key] = data;
      return {
        ...state,
        submitted: false,
        success: true
      };
    }
    case EDIT_USER_ERROR: {
      return {
        ...state,
        submitted: false,
        error: true
      };
    }
    case UPDATE_USER_STARTED: {
      return {
        ...state,
        submitted: true
      };
    }
    case UPDATE_USER_COMPLETED: {
      return {
        ...state,
        submitted: false,
        success: true
      };
    }
    case UPDATE_USER_ERROR: {
      return {
        ...state,
        submitted: false,
        error: true
      };
    }
    default:
      return state;
  }
}

export default userReducer;



// WEBPACK FOOTER //
// ./src/redux/reducers/userReducer.js